/**
 * Controller: membershipCategoriesCreateDescription
 */
angular.module('acme.view.application.membership.categories.create.description.controllers', [
    'acme.common.service.api',
    'acme.common.service.membership',
    'acme.common.factory.notice',
    'acme.common.service.validate'
  ])
  .controller('MembershipCategoriesCreateDescriptionController', ['$scope', 'MembershipService', 'ApiService', 'NoticeFactory', 'ValidateService', function ($scope, MembershipService, ApiService, NoticeFactory, ValidateService) {

    $scope.membershipCategoriesCreateDescription = {

      model: {},

      shortDescriptionMax: 300,
      shortDescriptionRemaining: 300,
      selectedPrimaryPhoto: '',

      summernoteConfig: {
        height: 300,
        focus: true,
        toolbar: [
          ['style', ['bold', 'italic', 'underline', 'clear']],
          ['fontsize', ['fontsize']],
          ['color', ['color']],
          ['para', ['ul', 'ol', 'paragraph']],
          ['height', ['height']]
        ]
      },

      validators: [],

      isSubmitted: false,

      notice: new NoticeFactory(),

      init: function () {
        this.model = MembershipService.getModel();

        $scope.$on('MembershipService::Update', this.onMembershipServiceUpdate);
        $scope.$on('MembershipCategoriesCreate::Update', this.onMembershipCategoryCreateUpdate);
        $scope.$on('MembershipCategoriesCreate::Save', this.onMembershipCategoryCreateSave);
        $scope.$on('upload::selectionChange', this.onUploadSelectionChange);
        $scope.$on('upload::queueUpdated', this.onUploadQueueUpdated);
        $scope.$on('upload::remove', this.onUploadRemove);
        $scope.$on('upload::done', this.onUploadDone);
        $scope.$on('upload::add', this.onUploadAdd);

        this.validators = [
          {
            field: 'membership-categories-create-description-short',
            greater: {
              message: 'Your description must be ' + $scope.membershipCategoriesCreateDescription.shortDescriptionMax + ' characters or fewer',
              test: function() {
                return {
                  less: ($scope.membershipCategoriesCreateDescription.model.shortDescription) ? $scope.membershipCategoriesCreateDescription.model.shortDescription.length : 0,
                  greater: $scope.membershipCategoriesCreateDescription.shortDescriptionMax,
                  equalTo: false
                };
              }
            }
          },
          {
            field: 'membership-categories-create-description-long',
            len: {
              message: 'Your description must not be empty',
              test: function() {
                return {
                  value: $scope.membershipCategoriesCreateDescription.model.description
                };
              }
            }
          }];

        ValidateService.addFieldTests(this.validators);

        this.initPrimaryPhoto();
      },

      initPrimaryPhoto: function() {
        var i, ii;
        if (this.model.images instanceof Array) {
          for (i = 0, ii = this.model.images.length; i < ii; i++) {
            if (this.model.images[i].primary) {
              this.selectedPrimaryPhoto = this.model.images[i].id;
            }
          }
        }
      },

      getError: function(fieldName) {
        return ValidateService.getError(fieldName);
      },

      checkShortDescription: function () {
        if (this.model.shortDescription) {
          console.log('ProgramsCreateController::checkShortDescription', this.model.shortDescription.length);
          if (this.model.shortDescription > this.shortDescriptionMax) {
            this.model.shortDescription = this.model.shortDescription.substr(0, this.shortDescriptionMax);
          }
        } else {
          this.model.shortDescription = '';
        }
        this.shortDescriptionRemaining = this.shortDescriptionMax - this.model.shortDescription.length;
      },

      checkForWhiteSpaces: function () {
        this.model.shortDescription = this.model.shortDescription.replace(/[\s\n]/g, ' ');
      },

      isValid: function(field) {
        var r = true;

        if (this.isSubmitted) {
          r = ValidateService.check(this.validators, field);
        }
        return r;
      },

      isPrimaryPhoto: function(id) {
        return (id === this.selectedPrimaryPhoto);
      },

      updatePrimaryPhoto: function() {
        var i, ii;

        if (this.model.images instanceof Array) {
          for (i = 0, ii = this.model.images.length; i < ii; i++) {
            this.model.images[i].primary = (this.selectedPrimaryPhoto === this.model.images[i].id);
          }
        }
      },

      hasImages: function() {
        return MembershipService.hasImages();
      },

      removePhoto: function(id) {
        var i, ii;

        if (this.model.images instanceof Array) {
          for (i = 0, ii = this.model.images.length; i < ii; i++) {
            if (this.model.images[i].id === id) {
              if (i === ii - 1) {
                this.model.images[0].primary = true;
                this.selectedPrimaryPhoto = this.model.images[0].id;
              } else if (i === 0 && this.model.images[i].id === this.selectedPrimaryPhoto && this.model.images.length > 1) {
                this.model.images[1].primary = true;
                this.selectedPrimaryPhoto = this.model.images[1].id;
              }
              this.model.images.splice(i, 1);
              break;
            }
          }
        }
      },

      save: function () {

        this.notice.hideErrorMessages();
        this.notice.hideSuccessMessages();

        this.updatePrimaryPhoto();
        MembershipService.setModel(this.model);

        self.isSubmitted = true;
        ValidateService.validate(this.validators);
      },

      success: {
        init: function (response) {
        },

        update: function (response) {
        }
      },

      error: {
        init: function (response) {
        },
        update: function (response) {
        }

      },

      onMembershipServiceUpdate: function (e, data) {
        //the parent model has changed
        var self = $scope.membershipCategoriesCreateDescription;
        self.model = MembershipService.getModel();
        self.initPrimaryPhoto();
      },

      onMembershipCategoryCreateUpdate: function (e, data) {
        // a tab has changed
        var self = $scope.membershipCategoriesCreateDescription;

        if (data.view === 'description') {
          self.onMembershipServiceUpdate();
        }
      },

      onMembershipCategoryCreateSave: function (e, data) {
        $scope.membershipCategoriesCreateDescription.save();
      },

      onUploadRemove: function(e, data) {
        var i, ii,
          self = $scope.membershipCategoriesCreateDescription;

        for (i=0,ii=self.model.images.length;i<ii;i++) {
          if (data.file.id === self.model.images[i].id) {
            self.model.images.splice(i, 1);
          }
        }

        console.log('MembershipCategoriesCreateDescriptionController::onUploadRemove', self.model.images);

      },

      onUploadAdd: function(e, data) {
        console.log('MembershipCategoriesCreateDescriptionController::onUploadAdd', data);
      },

      onUploadDone: function(e, data) {

        var self = $scope.membershipCategoriesCreateDescription;

        console.log('MembershipCategoriesCreateDescriptionController::onUploadDone', data);

        if (!(self.model.images instanceof Array)) {
          self.model.images = [];
        }

        self.model.images.push({
          id: data.file.uuid,
          description: data.file.thumbnailPath,
          preview: data.file.previewPath,
          screen: data.file.screenPath,
          primary: false
        });

        if (self.model.images.length === 1) {
          self.model.images[0].primary = true;
          self.selectedPrimaryPhoto = self.model.images[0].id;
        }

        console.log('MembershipCategoriesCreateDescriptionController::onUploadDone', self.model.images);

        $scope.$apply();

      },

      onUploadSelectionChange: function(e, data) {
        var i, ii,
          self = $scope.membershipCategoriesCreateDescription;

        if (!(self.model.images instanceof Array)) {
          self.model.images = [];
        }

        for (i=0,ii=self.model.images.length;i<ii;i++) {
          if (data.file) {
            self.model.images[i].primary = (data.file.id === self.model.images[i].id);
          }
        }
        console.log('MembershipCategoriesCreateDescriptionController::onUploadSelectionChange', data, self.model.images);
      },

      onUploadQueueUpdated: function(e, data) {
        console.log('MembershipCategoriesCreateDescriptionController::onUploadQueueUpdated', data);
      }

    };

    $scope.membershipCategoriesCreateDescription.init();

  }]);